import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Color from 'color';

import { CanvasConfettiContainer } from './styles';

function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}

function getAnimationSettings(originXA, originXB, colors) {
  return {
    startVelocity: 30,
    spread: 360,
    ticks: 60,
    zIndex: 0,
    particleCount: 150,
    origin: {
      x: randomInRange(originXA, originXB),
      y: Math.random() - 0.2,
    },
    colors: colors.map(({ value }) => Color(value).hex()),
  };
}

function ConfettiFireworks({ data }) {
  const refAnimationInstance = useRef(null);
  const [intervalId, setIntervalId] = useState(null);
  const [run, setRun] = useState(false);

  const getInstance = useCallback((instance) => {
    refAnimationInstance.current = instance;
  }, []);

  const nextTickAnimation = useCallback(() => {
    if (refAnimationInstance.current) {
      refAnimationInstance.current(
        getAnimationSettings(0.1, 0.3, data?.colors)
      );
      refAnimationInstance.current(
        getAnimationSettings(0.7, 0.9, data?.colors)
      );
    }
  }, [data?.colors]);

  useEffect(() => {
    if (run) {
      setIntervalId(setInterval(nextTickAnimation, 400));
    }
    if (!run) {
      setIntervalId(null);
    }
  }, [nextTickAnimation, run]);

  useEffect(() => {
    if (data?.start && !run) {
      setRun(true);
    }
    if (!data?.start && run) {
      clearInterval(intervalId);
      setRun(false);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [intervalId, data?.start, run, setRun]);

  return <CanvasConfettiContainer refConfetti={getInstance} />;
}

ConfettiFireworks.propTypes = {
  data: PropTypes.shape({
    colors: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.string,
      })
    ),
    start: PropTypes.bool,
  }),
  styles: PropTypes.shape({}),
};

ConfettiFireworks.defaultProps = {
  data: {
    colors: [
      { id: 'color1', value: '#bb0000' },
      { id: 'color2', value: '#ffffff' },
    ],
    start: false,
  },
  styles: {},
};

export default ConfettiFireworks;
